import React, { useState } from 'react';
import CommonModal from './CommonModal';
import { formatAmount } from '../../utils/tomPayments';

/**
 * Shown when a card payment the terminal approved could not be recorded by the POS. It stays until
 * staff deal with it: closing needs a second confirmation, and the approval stays stored (and
 * listed in the header banner) either way.
 */
const TomPaymentDialog = ({ isOpen, record, message, busy, onRetry, onClose }) => {
  const [confirmingClose, setConfirmingClose] = useState(false);
  const reference = record?.payload?.tom_response?.paymentSolutionReference || record?.payload?.tom_response?.reference;
  const amount = formatAmount(record?.amount);

  const close = () => {
    setConfirmingClose(false);
    onClose();
  };

  return (
    <CommonModal isOpen={isOpen} onClose={() => {}} elId="tomPaymentDialog" closeOnBackdropClick={false} closeOnEscape={false}>
      <div className="modal-header">
        <h5 className="modal-title">Card payment not recorded</h5>
      </div>
      <div className="modal-body" role="alertdialog" aria-live="assertive">
        <p>
          The card payment{amount ? ` of ${amount}` : ''} was approved on the terminal
          {reference ? ` (reference ${reference})` : ''} but the POS could not record it.
        </p>
        <p>
          <strong>Do NOT charge the customer again.</strong>
        </p>
        {message && (
          <p className="text-danger" data-testid="tom-dialog-message">
            {message}
          </p>
        )}
        {busy && <p data-testid="tom-dialog-busy">Trying to record it…</p>}
        {confirmingClose && (
          <p data-testid="tom-dialog-confirm-close">
            Close without recording? The payment stays saved on this device and a banner will remind you
            to record it. The order is not marked paid until it is recorded.
          </p>
        )}
      </div>
      <div className="modal-footer">
        {confirmingClose ? (
          <>
            <button type="button" className="btn btn-secondary" onClick={() => setConfirmingClose(false)}>
              Keep this open
            </button>
            <button type="button" className="btn btn-danger" onClick={close}>
              Yes, close
            </button>
          </>
        ) : (
          <>
            <button type="button" className="btn btn-secondary" onClick={() => setConfirmingClose(true)}>
              Close, I will fix it later
            </button>
            <button type="button" className="btn btnPrimary" disabled={busy} onClick={onRetry}>
              Try again
            </button>
          </>
        )}
      </div>
    </CommonModal>
  );
};

export default TomPaymentDialog;
